module.exports = __webpack_public_path__ + "img/4.5f76ff4b.jpg";